module.exports = __webpack_public_path__ + "static/img/products discription_cooler2.0680b649.jpg";